import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  batchList: []
};

const batchesReducerSlice = createSlice({
  name: 'batches',
  initialState,
  reducers: {
    updateBatches(state, action) {
      return {
        ...state,
        batchList: [...action.payload]
      };
    },
    updatebatch(state, action) {
      return {
        ...state,
        batchList: state.batchList.map((batch) => {
          if (batch._id === action.payload.id) {
            return action.data;
          }
          return batch;
        })
      };
    }
  }
});

export const batchesReducerAction = batchesReducerSlice.actions;
export const batchesReducers = batchesReducerSlice.reducer;
